import { useId } from 'react-id-generator';

//theme
import { CheckboxChangeParams } from 'primereact/checkbox';
import BeeCheckbox from './BeeCheckbox';
import BeeErrorLabel from './BeeErrorLabel';
import BeeInfoLabel from './BeeInfoLabel';
import './BeeValidatedCheckbox.scss';

type BeeValidatedCheckboxProps = {
  id?: string;
  label?: string;
  stateFalse?: string;
  stateTrue?: string;
  errorLabel?: string | null;
  neutralLabel?: string | null;
  validLabel?: string | null;
  value?: boolean | undefined | null;
  disabled?: boolean;
  formstate?: string;
  readOnly?: boolean;
  required?: boolean;
  onChange?: (e: CheckboxChangeParams) => void;
};
export function BeeValidatedCheckbox({
  id,
  label,
  errorLabel,
  neutralLabel,
  validLabel,
  value,
  disabled,
  formstate,
  stateTrue,
  stateFalse,
  required,
  readOnly,
  onChange
}: BeeValidatedCheckboxProps) {
  const currentId = useId(1, 'bee-val-checkbox-')[0];

  //classNames
  const labelClassNames = 'bee-validated-checkbox-label';

  const textSize = 'medium';
  const inputFormstate = formstate === 'none' ? 'neutral' : formstate;

  function change(e: CheckboxChangeParams) {
    if (!disabled && onChange) {
      onChange(e);
    }
  }

  const renderLabel = () => {
    return (
      <div className={labelClassNames}>
        {formstate === 'error' && errorLabel ? (
          <BeeErrorLabel size={textSize} label={errorLabel} visible={true} />
        ) : formstate === 'valid' && validLabel ? (
          <BeeInfoLabel
            size={textSize}
            label={validLabel}
            type={'valid'}
            visible={true}
          />
        ) : formstate === 'neutral' && neutralLabel ? (
          <BeeInfoLabel
            size={textSize}
            label={neutralLabel}
            type={'neutral'}
            visible={true}
          />
        ) : null}
      </div>
    );
  };
  return (
    <div className={'bee-validated-checkbox'} id={id ? id : currentId}>
      <BeeCheckbox
        label={label}
        value={value}
        disabled={disabled}
        formstate={inputFormstate}
        stateTrue={stateTrue}
        stateFalse={stateFalse}
        required={required}
        readOnly={readOnly}
        onChange={(e) => change(e)}
      />
      {formstate !== 'none' && (errorLabel || neutralLabel || validLabel)
        ? renderLabel()
        : null}
    </div>
  );
}

export default BeeValidatedCheckbox;
